<div class="mainDiv" id="preview_body">
    <div [ngClass]="!isInsightspopupOpen ? 'preview_body' : 'preview_expand'"  style="display:flex; justify-content:center;">
        <ng-container *ngIf="isSevenWidgetLayout; else checkThreeLayout">
            <div [ngClass]="!isInsightspopupOpen ? 'chart-grid-seven' : 'chart-grid-seven-expand'" seven-layout-root>
                <!-- Widget 1 — Left tall widget -->
                <div [ngClass]="!isInsightspopupOpen ? 'grid_item' : 'grid_item_expand'"
                    class="seven-widget-left"
                    id="grid_item_0"
                    [attr.grid_index]="0"
                    [attr.page_index]="pageCount">
                    <ng-container *ngTemplateOutlet="widgetTemplate; context:{ item: data[0], i: 0 }"></ng-container>
                </div>
 
                <!-- Widgets 2-7 — Right panel 2x3 grid -->
                <div class="seven-right-panel">
                    <div [ngClass]="!isInsightspopupOpen ? 'grid_item' : 'grid_item_expand'" *ngFor="let item of data | slice:1:(columnPerRowCount + 1); let i = index"
                        [id]="'grid_item_'+(i+1)"
                        [attr.grid_index]="i+1"
                        [attr.page_index]="pageCount">
                        <ng-container *ngTemplateOutlet="widgetTemplate; context:{ item: item, i: i+1 }"></ng-container>
                    </div>
                </div>
 
            </div>
        </ng-container>

        <ng-template #checkThreeLayout>
            <ng-container *ngIf="isThreeWidgetLayout; else normalGrid">
                <div class="chart-grid-three">
                    <div [ngClass]="!isInsightspopupOpen ? 'grid_item' : 'grid_item_expand'"
                        *ngFor="let item of data | slice:0:3; let i = index"
                        [id]="'grid_item_' + i"
                        [attr.grid_index]="i"
                        [attr.page_index]="pageCount">
                        <ng-container 
                        *ngTemplateOutlet="widgetTemplate; context:{ item: item, i: i }">
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-template>
  
        <ng-template #normalGrid>
        <!-- <div class="grid-container" [class.two-horizontal]="columnPerRowCount === 2" style="width:100%; " #gridContainer -->
         <div class="grid-container" style="width:100%; " #gridContainer
            [style.grid-template-columns]="data.length > 1 ? gridTempleteColumns : '100% 50%'" [ngStyle]="{ 'display': data.length == 1 ? 'grid' : 'grid' }">
            <!-- [ngStyle]="{ 'max-height': data.length == 1 ? '25.75rem' : '13rem','width': data.length == 1 ? '98%' : 'auto','margin-left': data.length == 1 ? '1%' : '0%'}" -->

            <div  [ngClass]="!isInsightspopupOpen ? 'grid_item' : 'grid_item_expand'" [attr.grid_index]="i" [attr.page_index]="pageCount" id="grid_item_{{i}}"
                *ngFor="let item of data;index as i">
                <ng-container *ngTemplateOutlet="widgetTemplate; context:{ item: item, i: i }"></ng-container>
                </div>
 
            </div>
        </ng-template>
 
    </div>
    <ng-template #widgetTemplate let-item="item" let-i="i">

    <ng-container *ngIf="item.previewChartPostion==-1">
        <div class="no_chart">
            <p>No chart configured</p>
        </div>
    </ng-container>

                <ng-container *ngIf="item.previewChartPostion!=-1">
                    <div class="itemHeader">
                        <!-- <p class="itemName">{{ item.widget_name}} </p> -->
                           <p class="itemName" [title]="item.selectedMetric && (item.metricdropdownOutput == 1 && data.length>=6 && item.metric[0]?.metric_value?.length > 1) ? (item.widget_name + ' - ' + item.selectedMetric) : item.widget_name">
                            {{ item.widget_name }}<ng-container *ngIf="item.selectedMetric && (item.metricdropdownOutput == 1 && data.length>=6 && item.metric[0]?.metric_value?.length > 1)"> - {{ item.selectedMetric }}</ng-container>
                            <ng-container *ngIf="_configService.selectedSnapshotType?.toLowerCase()?.includes('audience') ">
                                                        <span class="itemBrandLabel">{{ getSelectedBrandLabel(item) }}</span>
                            </ng-container>
                        </p>   

                        <div class="itemIcon" *ngIf="!hideCharts" [ngClass]="{'itemIcon--compact': data.length >= 6}">
                            <!-- Data Label checkbox: visible only for Trend as Widget in Text to Topics study -->
                            <ng-container *ngIf="item?.widgetchart_name === 'Trend as Widget' && _configService.selectedStudy === 'Text to Topics'">
                              <label class="trend-datalabel-toggle" [class.trend-datalabel-disabled]="item?.noData === true || item?.trendNotApplicable === true || !(item?.metric?.length > 0 && item?.metric[0]?.metric_value?.length > 0)" (click)="$event.stopPropagation()">
                                <input type="checkbox" [checked]="item.trendDataLabelVisible !== false" [disabled]="item?.noData === true || item?.trendNotApplicable === true || !(item?.metric?.length > 0 && item?.metric[0]?.metric_value?.length > 0)" (change)="toggleTrendDataLabel(item)">
                                <span>Data Label</span>
                              </label>
                            </ng-container>
                            <!-- <app-output-icons style="width:100%; display:flex;justify-content: end;" [widgetName]="item.item1.widgetName"
                                [visualization]="item.item1.visualization" [id]="i" [infoIcon]="item.item1.infoIcon"
                                [data]="item.item1.metric" [trendData]="item.item2.metric" [sort]="item.item1.sort" [isSort]="item.item1.isSort" [sortToggleFromParent]="sortToggle"
                                (iconClicked)="ClickedIconFun($event)" [item]="item.item1" (sortType)="sortWidget($event)" (defaultSortType)="defaultSortWidget($event)"></app-output-icons> -->
                        
                            <app-custom-output-icons [data]="item" [legendItems]="item.legendItems || []" [legendTable]="item.legendTable || null"  (dataBarsUpdated)="updateDataBars($event.item, $event.status)" [alldata]="data" (elementClickedStatus)="elementClickedStatus($event)" [widgetchartname]="item?.widgetchart_name" [id]="getGlobalIconId(i)" [datafromLayout]="datafromLayout" [multimetricselect]="multimetricselect" [isDisabled]="item?.noData === true" ></app-custom-output-icons>
                        </div>
                    </div>
                    <!-- <hr> -->

                    <div [ngClass]="!isInsightspopupOpen ? 'chart' : 'chart_expand'"
                         (wheel)="onChartScroll($event, i)">
                    <div class="chart-section" *ngIf="item.metric.length!=0 && item.metric[0].metric_value.length>0 && item.noData!=true && !(_configService.selectedSnapshotType.toLowerCase().includes('multi') && data.length==1 && (item.widgetchart_name=='FUNNEL CHART' || item.widgetchart_name=='Line Chart')) && (item.widgetchart_name !== 'Trend as Widget' || isTrendWidgetDataReady(item))">
                        <!-- <ng-container> -->
                        <!-- <app-snapshot-chartsparent *ngIf="item.item1.metric.length>0 && showChart" [snapProduct]="'custom'" [chart]="item.item1.visualization" [id]="i" [data]="item.item1.metric"
                            [height]="height" [sort]="item.item1.sort" [WidgetDetails]="item.item1"></app-snapshot-chartsparent>
                        -->
                                <app-snapshot-chartsparent
                                *ngIf="item?.widgetchart_name !== 'Table'; else tableChart"
                                [snapProduct]="'custom'"
                                [isOutput]="true"
                                [customData]="item"
                                [gridTempleteColumns]="gridTempleteColumns"
                                [id]="getGlobalIconId(i)"
                                [height]="data.length === 1 ? '21em' : isInsightspopupOpen ? '11em' : (isSevenWidgetLayout && i === 0 || isThreeWidgetLayout) && item?.widgetchart_name === 'Gauge' ? '13em' : 'calc(100% - 2.6rem)'"
                                [widgetCount]="data.length"
                                [widgetName]="item?.widget_name"
                                [globalColorMap]="globalColorMap"
                                [layoutWidth]="columnPerRowCount"
                                [DataLabelOn]="item.trendDataLabelVisible !== false">
                                </app-snapshot-chartsparent>
                            <!-- <app-snapshot-chartsparent
  *ngIf="item.widgetchart_name !== 'Table'; else tableChart"
  [snapProduct]="'custom'"
  [isOutput]="true"
  [customData]="item"
  [gridTempleteColumns]="gridTempleteColumns"
  [id]="+(i.toString()+pageCount.toString())"
  [height]="
    data.length === 1
      ? '21em'
      : (isInsightspopupOpen ? '11em' : 'calc(100% - 2rem)')
  "
  [widgetCount]="data.length"
>
</app-snapshot-chartsparent> -->


                            <ng-template #tableChart>
                                <app-snapshot-chartsparent
                                [snapProduct]="'custom'"
                                *ngIf="item?.toggleButton"
                                [enableDataBars]="item?.enableDataBars"
                                [isOutput]="true"
                                [customData]="item"
                                [gridTempleteColumns]="gridTempleteColumns"
                                [id]="+(i.toString()+pageCount.toString())"
                                [height]="isInsightspopupOpen ? (data.length === 1 ? '1rem' : '0.5rem') : (data.length === 1 ? '22rem' : '9rem')"
                                [widgetCount]="data.length"
                                [globalColorMap]="globalColorMap"
                                [layoutWidth]="columnPerRowCount">
                            </app-snapshot-chartsparent>
                            </ng-template>
                    </div>
                    <div class="chart-section" *ngIf="data.length==1 && (item?.widgetchart_name=='FUNNEL CHART' || item?.widgetchart_name=='Line Chart') && _configService.selectedSnapshotType.toLowerCase().includes('multi')">
                        <div class="grid-container-multiFunnel">
                            <div class="grid-item-multiFunnel" [ngStyle]="{'width': (i % 3 === 0) ? 'auto' : 'auto', 'height':'auto'}"
                                *ngFor="let cell of gridData;let i=index">
                                <h3 style="font-size: 0.9em;">{{cell.header}}</h3>
                                <hr>
                                <!-- <app-snapshot-chartsparent [snapProduct]="'custom'"  style="width: 98%; height: 100%;"
                              [customData]="customData" [isOutput]="false" [popUp]="true"  [height]="'10em'"></app-snapshot-chartsparent> -->
                                <app-funnelchart1-custom *ngIf="item?.widgetchart_name=='FUNNEL CHART' || item?.widgetchart_name=='Line Chart'"
                                    [selectedBrand]="cell.header" [isOutput]="true" [multiFunnelPopup]="true"
                                    [popUp]="false" [customData]="cell.data" [id]="i+90" [height]="'9em'"
                                    [gridTempleteColumns]="''"  [showXaxisLabels]="i%3==0?true:false" [widgetName]="item?.widget_name"></app-funnelchart1-custom>
                            </div>
                        </div>
                    </div>
                    <div class="chart-section-text" *ngIf="item?.metric?.length==0 || item?.metric[0]?.metric_value?.length<1">
                        <!-- <div *ngIf="item.item1.metric.length<1 && item.item1.noData==undefined">Widget is not configured.</div> -->
                        <div *ngIf="item?.metric?.length==0 || item?.metric[0]?.metric_value?.length<1 || item?.noData==true">No data available for the selection.</div>
                    </div>
                    </div>
                    <div class="insight" [class.open]="mounted" id="insight-{{i}}">
                      <ng-container *ngIf="(singleInsight != null && singleInsight.widgetName == item?.widget_name); else InsightTemplate">
                          <div class="loader-container" *ngIf="(singleInsight != null && singleInsight.widgetName == item?.widget_name)">
                              <app-insights-loader label="Generating insights"></app-insights-loader>
                          </div>
                      </ng-container>
                      <ng-template #InsightTemplate>
                          <div *ngIf="!isLoading || (singleInsight != null && singleInsight.widgetName == item?.widget_name)" >
                              <ul class ="insight-list" *ngIf="insightsData!=undefined">
                                <ng-container *ngIf="insightsData[item?.widget_name]!=null">
                                    <li class="insight-point" *ngFor="let insightitem of insightsData[item?.widget_name]['Value']">{{insightitem}}</li>
                                </ng-container>
                                <ng-container *ngIf="insightsData[item?.widget_name]==null"> <li class="insight-point">No Data Available</li></ng-container>
                            </ul>
                            <ul class ="insight-list"*ngIf="insightsData==undefined">
                                <li class="insight-point">No Data Available</li>
                            </ul>
                          </div>
                          <div class="loader-container" *ngIf="isLoading || (singleInsight != null && singleInsight.widgetName == item.widget_name)">
                              <app-insights-loader label="Generating insights"></app-insights-loader>
                          </div>
                      </ng-template>
                    </div>
                </ng-container>
                </ng-template>
            </div>



        <!-- <div style="height:100%;width:5%;" *ngIf="datafromLayout.length>1" id="pagination-div">

            <div style="position:relative;top:33.5%;left:25%;" >
                <div class="leftPageDiv" (click)="Paginate('left')" [ngClass]="{'disabled':disableLeftClick}">
                    <span class="material-symbols-outlined leftPageClick">arrow_circle_left</span>
                </div>
                <div class="rightPageDiv" (click)="Paginate('right')" [ngClass]="{'disabled':disableRightClick}">
                    <span class="material-symbols-outlined rightPageClick">arrow_circle_right</span>
                </div>
            </div>
        </div> -->
    


<app-shared-popup-snapshot
    *ngIf="showGlobalDefaultPopup"
    [showGlobalDefaultPopup] ="showGlobalDefaultPopup">
</app-shared-popup-snapshot>
